import React, { Component } from 'react';
import { Loader } from 'react-loaders';
import { translate } from 'react-i18next';

import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import Content from 'components/Content/Content';
import Seeker from 'components/Seeker/Seeker';
import InfoView from 'components/InfoView/InfoView';
import CustomModal from 'components/CustomModal/CustomModal';

import RequestService from 'services/RequestService';

import 'loaders.css/loaders.min.css';
import './Layout.css';

declare var CONFIGURATIONS;

class Layout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      blocking: true,
      collections: [],
    };
  }

  componentWillMount = () => {
    RequestService.getRequest(`${CONFIGURATIONS.ckan_url}/group_show?id=cartoteca`).then((res) => {
      const groups = res.result.groups.map((g) => g.name);
      const urls = [];
      const collections = [];
      groups.forEach((g) => {
        urls.push(RequestService.getRequest(`${CONFIGURATIONS.ckan_url}/group_show?id=${g}`));
      });

      Promise.all(urls).then((responses) => {
        responses.forEach((r) => {
          collections.push(r.result);
        });

        this.setState({ collections, blocking: false });
      });
    });
  }

  block = () => {
    this.setState({ blocking: true });
  }

  unblock = () => {
    this.setState({ blocking: false });
  }

  render() {
    const { option } = this.props;
    const { blocking, collections } = this.state;

    return (
      <div className='content-wrapper'>
        <Header />
        <section className='layout-wrapper'>
          { option === 'main' ?
            <Content collections={collections} />
          : option === 'search' ?
            <Seeker collections={collections} block={this.block} unblock={this.unblock} />
          : option === 'info' ?
            <InfoView block={this.block} unblock={this.unblock} />
          : null }
        </section>
        <Footer />
        <CustomModal open={blocking} blocking={true} onClose={this.unblock}>
          <div className='block-loader-container'>
            <Loader active type={'ball-triangle-path'} color='#006699' />
          </div>
        </CustomModal>
      </div>
    );
  }
}

export default translate()(Layout);
